module.exports = __webpack_public_path__ + "assets/img/336654f563bc5d44be7a7d31ba43f1e2.svg";